module.exports = __webpack_public_path__ + "static/img/5.3f0426a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/zh/5.png
// module id = +vqq
// module chunks = 0